import { render, staticRenderFns } from "./NoPermitidoComponent.vue?vue&type=template&id=a2cfe62c&scoped=true&"
import script from "./NoPermitidoComponent.vue?vue&type=script&lang=js&"
export * from "./NoPermitidoComponent.vue?vue&type=script&lang=js&"
import style0 from "./NoPermitidoComponent.vue?vue&type=style&index=0&id=a2cfe62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cfe62c",
  null
  
)

export default component.exports